<template>
  <div class="actual_section"><div class="perfil-jugador avenirnextltpro-bold-big-stone-10px">Perfil jugador</div></div>
</template>

<script>
export default {
  name: "ActualSection",
};
</script>

<style>
.actual_section,
.actual_section-1,
.actual_section-2,
.actual_section-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2px 4px;
  position: relative;
  width: fit-content;
}

.perfil-jugador,
.perfil-jugador-1,
.perfil-jugador-2,
.perfil-jugador-3 {
  letter-spacing: -0.1px;
  line-height: 17px;
  margin-top: -2px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
</style>
